import MobileSearch from '@/features/searchV2/pages/search';

const MobileSearchPage = () => {
  return <MobileSearch />;
};

export default MobileSearchPage;
